// Variation
declare const variationId: string;

export function isVariation(myVariationId: string) {
    return variationId === myVariationId;
}

export function getVariation() {
    return variationId;
}

export function isWorkflow(workflowName: string) {
    const workflowElement = document.getElementById(workflowName);

    return workflowElement != null;
}